import React from 'react';
import { Cookie, Eye, BarChart, Settings } from 'lucide-react';
import './LegalPage.css';

export default function CookiePage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>🍪 Cookie-Richtlinie</h1>
        <p className="legal-intro">
          Diese Seite erklärt, wie PedalScot Cookies und ähnliche Technologien einsetzt.
        </p>

        <section>
          <h2><Cookie size={24} className="section-icon" /> 1. Was sind Cookies?</h2>
          <p>
            Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden. Sie helfen uns, 
            die Website funktionsfähig zu machen und Ihr Nutzererlebnis zu verbessern.
          </p>
        </section>

        <section>
          <h2>2. Welche Cookies verwenden wir?</h2>
          
          <h3><Settings size={20} className="inline-icon" /> 2.1 Notwendige Cookies</h3>
          <div className="cookie-table">
            <table>
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Zweck</th>
                  <th>Laufzeit</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>auth_token</code></td>
                  <td>Aufrechterhaltung der Anmeldung</td>
                  <td>Session / 7 Tage</td>
                </tr>
                <tr>
                  <td><code>language</code></td>
                  <td>Spracheinstellung speichern</td>
                  <td>1 Jahr</td>
                </tr>
                <tr>
                  <td><code>cookie_consent</code></td>
                  <td>Speichert Ihre Cookie-Präferenzen</td>
                  <td>1 Jahr</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)</p>
          <p><strong>Opt-Out:</strong> Nicht möglich (technisch notwendig)</p>

          <h3><BarChart size={20} className="inline-icon" /> 2.2 Analyse-Cookies (PostHog)</h3>
          <div className="cookie-table">
            <table>
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Zweck</th>
                  <th>Laufzeit</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>ph_*</code></td>
                  <td>Anonymisierte Nutzungsstatistiken</td>
                  <td>1 Jahr</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</p>
          <p><strong>Opt-Out:</strong> Möglich über Cookie-Einstellungen</p>
        </section>

        <section>
          <h2><Eye size={24} className="section-icon" /> 3. Ihre Cookie-Einstellungen</h2>
          <p>
            Sie können Ihre Cookie-Präferenzen jederzeit ändern:
          </p>
          <ul>
            <li><strong>Browser-Einstellungen:</strong> Löschen oder blockieren Sie Cookies in Ihrem Browser</li>
            <li><strong>Do Not Track:</strong> Wir respektieren das DNT-Signal Ihres Browsers</li>
            <li><strong>Opt-Out PostHog:</strong> <a href="https://posthog.com/docs/privacy" target="_blank" rel="noopener noreferrer">PostHog Opt-Out</a></li>
          </ul>

          <div className="info-box">
            <p>
              <strong>Hinweis:</strong> Das Deaktivieren von Cookies kann die Funktionalität 
              der Website einschränken.
            </p>
          </div>
        </section>

        <section>
          <h2>4. Cookies von Drittanbietern</h2>
          <p>Folgende Drittanbieter setzen Cookies auf unserer Website:</p>
          <ul>
            <li><strong>PostHog:</strong> Analytics (DSGVO-konform, EU-Server)</li>
            <li><strong>OpenStreetMap / Leaflet:</strong> Karten-Darstellung</li>
          </ul>
        </section>

        <section>
          <h2>5. Browser-spezifische Anleitungen</h2>
          <p>So löschen Sie Cookies in Ihrem Browser:</p>
          <ul>
            <li><strong>Chrome:</strong> Einstellungen → Datenschutz und Sicherheit → Cookies</li>
            <li><strong>Firefox:</strong> Einstellungen → Datenschutz & Sicherheit</li>
            <li><strong>Safari:</strong> Einstellungen → Datenschutz</li>
            <li><strong>Edge:</strong> Einstellungen → Datenschutz, Suche und Dienste</li>
          </ul>
        </section>

        <section>
          <h2>6. Änderungen dieser Richtlinie</h2>
          <p>
            Wir behalten uns vor, diese Cookie-Richtlinie zu aktualisieren. Die aktuelle Version 
            finden Sie stets auf dieser Seite.
          </p>
        </section>

        <section>
          <h2>7. Kontakt</h2>
          <p>
            Bei Fragen zu Cookies kontaktieren Sie uns:<br />
            E-Mail: <a href="mailto:datenschutz@pedalscot.com">datenschutz@pedalscot.com</a>
          </p>
        </section>

        <section className="legal-meta">
          <p>
            <strong>Zuletzt aktualisiert:</strong> Januar 2025<br />
            <strong>Version:</strong> 1.0
          </p>
        </section>
      </div>
    </div>
  );
}
